import LegalPageLayout from "./LegalPageLayout";

const SECTIONS = [
  {
    heading: "1. Overview",
    blocks: [
      {
        type: "p",
        text: "This Refund Policy explains how refunds and cancellations work for MagicBolt AI subscriptions, operated by MagicBolt Private Limited. By subscribing to a paid plan, you agree to the terms below.",
      },
    ],
  },
  {
    heading: "2. Free Trial",
    blocks: [
      {
        type: "p",
        text: "Where offered, MagicBolt AI plans start with a free trial that requires no credit card. You will not be charged unless you actively choose a paid plan at the end of the trial, so no refund is applicable during the trial period.",
      },
    ],
  },
  {
    heading: "3. Monthly Subscriptions",
    blocks: [
      {
        type: "p",
        text: "Monthly subscription fees are billed in advance for each billing cycle. You may cancel at any time to stop future renewals; cancellation prevents the next charge but does not refund the current, already-billed cycle, during which you retain full access to the platform.",
      },
    ],
  },
  {
    heading: "4. Yearly Subscriptions",
    blocks: [
      {
        type: "p",
        text: "Yearly plans are billed upfront at a discounted annual rate. If you cancel a yearly plan within 7 days of the initial purchase and have made minimal use of the platform, you may request a full refund. After 7 days, yearly subscriptions are non-refundable, but you will retain access through the remainder of the paid term.",
      },
    ],
  },
  {
    heading: "5. Lifetime Plans",
    blocks: [
      {
        type: "p",
        text: "Lifetime plans are a one-time purchase. If you are not satisfied, you may request a full refund within 30 days of the initial purchase. After 30 days, lifetime purchases are non-refundable.",
      },
    ],
  },
  {
    heading: "6. Add-on Channels",
    blocks: [
      {
        type: "p",
        text: "Additional channels purchased on top of a plan (e.g. extra GBP, Facebook or Instagram connections) follow the same billing cycle as your base subscription and are subject to the same refund terms above.",
      },
    ],
  },
  {
    heading: "7. Non-Refundable Circumstances",
    blocks: [
      { type: "p", text: "Refunds will not be issued where:" },
      {
        type: "ul",
        items: [
          "The request is made after the applicable refund window (7 days for yearly plans; 30 days for lifetime plans; not applicable to monthly plans after billing).",
          "The account was suspended or terminated for violation of our Terms & Conditions.",
          "The dissatisfaction relates to a connected third-party platform (Google, Meta, WordPress, etc.) outside MagicBolt AI's control.",
          "Significant usage of the platform's automation features has already occurred during the billing period.",
        ],
      },
    ],
  },
  {
    heading: "8. How to Request a Refund",
    blocks: [
      {
        type: "p",
        text: "To request a refund, email support@magicbolt.ai with your account email and reason for the request. We review each request individually and may ask for additional details before approving.",
      },
    ],
  },
  {
    heading: "9. Processing Time",
    blocks: [
      {
        type: "p",
        text: "Approved refunds are processed to the original payment method within 7–10 business days. Processing times may vary depending on your bank or payment provider.",
      },
    ],
  },
  {
    heading: "10. Cancellations",
    blocks: [
      {
        type: "p",
        text: "You can cancel your subscription anytime from your account dashboard or by contacting support. Cancellation stops future billing; it does not automatically trigger a refund for the current period unless you qualify under the terms above.",
      },
    ],
  },
  {
    heading: "11. Contact Us",
    blocks: [
      {
        type: "p",
        text: "For refund or billing questions, contact support@magicbolt.ai or write to MagicBolt Private Limited, Zone-I, Maharana Pratap Nagar, Bhopal, Madhya Pradesh 462012, India.",
      },
    ],
  },
];

export default function RefundPolicyPage() {
  return (
    <LegalPageLayout
      testId="refund-policy-page"
      title="Refund Policy - MagicBolt AI"
      description="Understand how refunds, cancellations and billing work for MagicBolt AI monthly and yearly subscriptions."
      path="/refund-policy"
      eyebrow="Fair & transparent billing"
      heading="Refund Policy"
      updated="July 20, 2026"
      sections={SECTIONS}
    />
  );
}
